import { create } from "zustand";
import type { FaceEnrollment } from "../types";

interface FaceEnrollmentState {
	modalOpen: boolean;
	editingItem: FaceEnrollment | null;
	openAddModal: () => void;
	openEditModal: (item: FaceEnrollment) => void;
	closeModal: () => void;
}

export const useFaceEnrollmentStore = create<FaceEnrollmentState>((set) => ({
	modalOpen: false,
	editingItem: null,
	openAddModal: () => set({ modalOpen: true, editingItem: null }),
	openEditModal: (item) => set({ modalOpen: true, editingItem: item }),
	closeModal: () => set({ modalOpen: false, editingItem: null }),
}));
